module.exports = __webpack_public_path__ + "81a0183f38fcd0282d8674d6ef2e391c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/thumbnail.png
// module id = 1792
// module chunks = 0